import type { RichTextProps } from './types'

export default function RichText({ className, children }: RichTextProps) {
	const classes = `rich-text${className ? ` ${className}` : ''}`

	if (typeof children !== 'string') {
		return <div className={classes}>{children}</div>
	}

	return (
		<div
			className={classes}
			dangerouslySetInnerHTML={{ __html: children }}
			suppressHydrationWarning
		/>
	)
}
